import { render, staticRenderFns } from "./ListFamily.vue?vue&type=template&id=fc5c8750&scoped=true"
import script from "./ListFamily.vue?vue&type=script&lang=js"
export * from "./ListFamily.vue?vue&type=script&lang=js"
import style0 from "./ListFamily.vue?vue&type=style&index=0&id=fc5c8750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5c8750",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/ListFamily.vue
// module id = 2121
// module chunks = 31